import getInstallationServicePricingData from "./InstallationService/getInstallationServicePricingData";

const isZipcodeEligibleForInstallationService = async (
  serviceTierId: number,
  zipcode: string,
  itemNumberId: number
): Promise<boolean> => {
  const isEligible = await getInstallationServicePricingData(
    serviceTierId,
    zipcode,
    itemNumberId
  ).then((result) => {
    return !!result;
  });

  return isEligible;
};

export default isZipcodeEligibleForInstallationService;
